<template>
  <section class="container px-0 pb-4">
    <section v-if="user">
      <!-- Profile -->
      <div class="row">
        <div class="col-12 d-flex justify-content-start align-items-center py-3" v-if="lineProfile">
          <div>
            <img :src="lineProfile.pictureUrl" class="rounded-circle" width="40">
          </div>
          <div class="pl-2 flex-fill">
            {{ $i18n.t('message.line_liff.hello') }} {{ lineProfile.displayName }}
          </div>
          <div>
            <div class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarLanguage" role="button" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                <img :src="flagImage">
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarLanguage">
                <a class="dropdown-item"
                    href="#"
                    @click.prevent="$i18n.locale = 'en'">
                  English
                </a>
                <a class="dropdown-item"
                    href="#"
                    @click.prevent="$i18n.locale = 'th'">
                  ภาษาไทย
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <promotion-slider :perPage="2"/> -->
    
      <!-- Popular services -->
      <div class="row">
        <div class="col-12">
          <h5>{{ $t('message.home.popular_services') }}</h5>
        </div>
        <div class="col-4 text-center" 
            :class="{'pb-3' : $mq.phone}" 
            v-for="(service, index) in sortedServices"
            v-if="service.parent_id === 0 && service.service_type === 'popular' && service.is_hidden === 0">
          <router-link :to="service.route_url" tag="a" class="no-style">
            <div>
              <img :src="service.picture" alt="" class="img-fluid rounded">
            </div>
            <div class="text-small mt-2">
              {{ service | multiLangName  }}
            </div>
          </router-link>
        </div>
      </div>
      
      <!-- Special services -->
      <div class="row mt-4">
        <div class="col-12">
          <h5>{{ $t('message.home.specialty_services') }}</h5>
        </div>
        <div class="col-4 text-center" 
            :class="{'pb-3' : $mq.phone}" 
            v-for="(service, index) in sortedServices"
            v-if="service.parent_id === 0 && service.service_type === 'special' && service.is_hidden === 0">
          <router-link :to="getSpecialServicePath(service)" tag="a" class="no-style">
            <div>
              <img :src="service.picture" alt="" class="img-fluid rounded">
            </div>
            <div class="text-small mt-2">
              {{ service | multiLangName  }}
            </div>
          </router-link>
        </div>
      </div>
    </section>
    <section v-else>
      <loader/>
    </section>
  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import liff from '@line/liff'
  import Loader from '../loader/Loader'
  import PromotionSlider from '../promotion/Slider'
  import loginHelpers from '../../helpers/loginHelpers'
  import axios from 'axios'
  
  export default {
    components: {
      Loader,
      PromotionSlider
    },
    data () {
      return {
        message: null,
        idToken: null
      }
    },
    computed: {
      ...mapState('auth', ['isLineLoggedIn', 'lineProfile']),
      ...mapGetters({
        globalState: 'globalVal/getState',
        user: 'auth/getUser'
      }),
      sortedServices () {
        return this._.orderBy(this.globalState.services, ['position'], ['asc'])
      },
      flagImage () {
        return (this.$i18n.locale === 'en') ? '/static/img/flag-en.jpg' : '/static/img/flag-th.jpg'
      }
    },
    methods: {
      getSpecialServicePath (service) {
        let url = service.route_url
        if (url === '/service-requests/booking') {
          url = url + `?service_id=${service.id}`
        }
        return url
      },
      async checkEmailLineAccount (email) {
        if (email) {
          const nonce = await loginHelpers.getNonce()
          const url = 'auth/check-email-line-account'
          const submitData = {
            nonce: nonce,
            line_id: this.lineProfile.userId,
            name: this.lineProfile.displayName,
            email: email,
            picture: this.lineProfile.pictureUrl
          }
          const { data } = await axios.post(url, submitData)
          if (data) {
            const user = data.user
            this.$store.commit('auth/SET_TOKEN', user.token)
            const userData = loginHelpers.getUserData({ user: user })
            this.$store.commit('auth/SET_USER_DATA', userData)
            this.$store.commit('auth/SET_IS_LINE_LOGGED_IN', true)
          }
        }
      },
      async getLineProfile () {
        const profile = await liff.getProfile()
        this.$store.commit('auth/SET_LINE_PROFILE', profile)
        const decodedIdToken = await liff.getDecodedIDToken()
        this.idToken = decodedIdToken
        const email = decodedIdToken.email
        if (email) {
          this.checkEmailLineAccount(email)
        }
      }
    },
    async mounted () {
      if (!this.lineProfile) {
        await liff.init({ liffId: '2007200101-kKB7dXL1' })
        if (liff.isLoggedIn()) {
          this.message = 'You already logged in Line'
          this.getLineProfile()
        } else {
          const profile = {
            userId: 'Uc7271c353980ddfefcc59eeda48dda0f',
            displayName: 'Komkid C.',
            pictureUrl: 'https://media.creativemornings.com/uploads/user/avatar/120448/profile-circle.png'
          }
          this.$store.commit('auth/SET_LINE_PROFILE', profile)
          this.checkEmailLineAccount('komkid1@hotmail.com')
          this.message = 'Error no Line logged in'
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/lineLiff/Home.vue